/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ClmUserInfo } from './ClmUserInfo';
import {
    ClmUserInfoFromJSON,
    ClmUserInfoFromJSONTyped,
    ClmUserInfoToJSON,
    ClmUserInfoToJSONTyped,
} from './ClmUserInfo';
import type { PartnerAddress } from './PartnerAddress';
import {
    PartnerAddressFromJSON,
    PartnerAddressFromJSONTyped,
    PartnerAddressToJSON,
    PartnerAddressToJSONTyped,
} from './PartnerAddress';
import type { PartnerName } from './PartnerName';
import {
    PartnerNameFromJSON,
    PartnerNameFromJSONTyped,
    PartnerNameToJSON,
    PartnerNameToJSONTyped,
} from './PartnerName';

/**
 * 
 * @export
 * @interface ViDetails
 */
export interface ViDetails {
    /**
     * 
     * @type {string}
     * @memberof ViDetails
     */
    partnerUid?: string;
    /**
     * 
     * @type {string}
     * @memberof ViDetails
     */
    businessRelationshipNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof ViDetails
     */
    emailAddress?: string;
    /**
     * 
     * @type {string}
     * @memberof ViDetails
     */
    mobileNumber?: string;
    /**
     * 
     * @type {PartnerName}
     * @memberof ViDetails
     */
    name?: PartnerName;
    /**
     * 
     * @type {PartnerAddress}
     * @memberof ViDetails
     */
    address?: PartnerAddress;
    /**
     * 
     * @type {Date}
     * @memberof ViDetails
     */
    dateOfBirth?: Date;
    /**
     * 
     * @type {string}
     * @memberof ViDetails
     */
    nationality?: string;
    /**
     * 
     * @type {ClmUserInfo}
     * @memberof ViDetails
     */
    clmUserInfo?: ClmUserInfo;
    /**
     * 
     * @type {string}
     * @memberof ViDetails
     */
    language?: string;
}

/**
 * Check if a given object implements the ViDetails interface.
 */
export function instanceOfViDetails(value: object): value is ViDetails {
    return true;
}

export function ViDetailsFromJSON(json: any): ViDetails {
    return ViDetailsFromJSONTyped(json, false);
}

export function ViDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ViDetails {
    if (json == null) {
        return json;
    }
    return {
        
        'partnerUid': json['partnerUid'] == null ? undefined : json['partnerUid'],
        'businessRelationshipNumber': json['businessRelationshipNumber'] == null ? undefined : json['businessRelationshipNumber'],
        'emailAddress': json['emailAddress'] == null ? undefined : json['emailAddress'],
        'mobileNumber': json['mobileNumber'] == null ? undefined : json['mobileNumber'],
        'name': json['name'] == null ? undefined : PartnerNameFromJSON(json['name']),
        'address': json['address'] == null ? undefined : PartnerAddressFromJSON(json['address']),
        'dateOfBirth': json['dateOfBirth'] == null ? undefined : (new Date(json['dateOfBirth'])),
        'nationality': json['nationality'] == null ? undefined : json['nationality'],
        'clmUserInfo': json['clmUserInfo'] == null ? undefined : ClmUserInfoFromJSON(json['clmUserInfo']),
        'language': json['language'] == null ? undefined : json['language'],
    };
}

export function ViDetailsToJSON(json: any): ViDetails {
    return ViDetailsToJSONTyped(json, false);
}

export function ViDetailsToJSONTyped(value?: ViDetails | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'partnerUid': value['partnerUid'],
        'businessRelationshipNumber': value['businessRelationshipNumber'],
        'emailAddress': value['emailAddress'],
        'mobileNumber': value['mobileNumber'],
        'name': PartnerNameToJSON(value['name']),
        'address': PartnerAddressToJSON(value['address']),
        'dateOfBirth': value['dateOfBirth'] == null ? value['dateOfBirth'] : value['dateOfBirth'].toISOString().substring(0,10),
        'nationality': value['nationality'],
        'clmUserInfo': ClmUserInfoToJSON(value['clmUserInfo']),
        'language': value['language'],
    };
}

